import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
} from "@mui/material";
import {
  SaveTestInstrument,
  UpdateTestInstrument,
} from "../../../../services/TestLibService";
import { NotificationManager } from "react-notifications";

const AddTestInstrumentDialog = ({ open, onClose, onSave, selectedInstrument }) => {
  const [machineId, setMachineId] = useState("");
  const [name, setName] = useState("");

  useEffect(() => {
    if (selectedInstrument) {
      setMachineId(selectedInstrument.machineId || "");
      setName(selectedInstrument.name || "");
    } else {
      setMachineId("");
      setName("");
    }
  }, [selectedInstrument]);

  const handleSave = async () => {
    try {
      const instrumentData = { machineId, name };
      let response;

      if (selectedInstrument) {
        response = await UpdateTestInstrument(instrumentData);
        NotificationManager.success("Test instrument updated successfully");
      } else {
        response = await SaveTestInstrument(instrumentData);
        NotificationManager.success("Test instrument saved successfully");
      }

      if (response.status === 200) {
        onSave();
        onClose();
      } else {
        NotificationManager.error("Error saving test instrument");
      }
    } catch (error) {
      NotificationManager.error("Error saving test instrument");
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        {selectedInstrument ? "Update Test Instrument" : "Add New Test Instrument"}
      </DialogTitle>
      <DialogContent>
        <TextField
          label="Machine ID"
          value={machineId}
          onChange={(e) => setMachineId(e.target.value)}
          fullWidth
          margin="dense"
          variant="outlined"
          
          InputProps={{
            readOnly: !!selectedInstrument,
            inputProps: {
              maxLength: 6, // Set your desired maximum length here
            },
          }}
        />
        <TextField
          label="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          margin="dense"
          variant="outlined"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          {selectedInstrument ? "Update" : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddTestInstrumentDialog;
